module.exports = __webpack_public_path__ + "static/19-2-8ae331309655f57173c68f176b3afaf3.jpg";